import type { Dispatch, SetStateAction } from 'react';
import { useState } from 'react';

import { Button, Dialog, DialogContent, DialogFooter, DialogTitle } from 'design-system';

const ConfirmDialog = ({
  open,
  setOpen,
  deleteCallback
}: {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  deleteCallback: () => void;
}) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const close = () => {
    setOpen(false);
  };

  const deleteToken = () => {
    setIsDeleting(true);
    deleteCallback();
  };

  return (
    <Dialog
      open={open}
      onOpenChange={nextOpen => {
        if (!nextOpen) close();
      }}
    >
      <DialogContent
        showCloseButton={false}
        className='bg-gx-main-background text-gx-text sm:max-w-[610px]'
      >
        <DialogTitle>Remove API token?</DialogTitle>
        <p>This action cannot be undone, and any applications using this token will lose access.</p>
        <DialogFooter>
          <Button
            type='button'
            variant='outline'
            onClick={close}
          >
            Cancel
          </Button>
          <Button
            disabled={isDeleting}
            type='button'
            onClick={deleteToken}
          >
            Delete token
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
export default ConfirmDialog;
